import { render, staticRenderFns } from "./arrivalRecordQuery.vue?vue&type=template&id=2f37b3c8&scoped=true"
import script from "./arrivalRecordQuery.vue?vue&type=script&lang=js"
export * from "./arrivalRecordQuery.vue?vue&type=script&lang=js"
import style0 from "./arrivalRecordQuery.vue?vue&type=style&index=0&id=2f37b3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37b3c8",
  null
  
)

export default component.exports